export const ERROR_MESSAGES = {
  defaultApiError: '問題が発生しました。時間を置いて再度お試しください。',
  networkError: '通信に失敗しました',
  codeRequired: '確認コードを入力してください',
  codeMismatchForgotPassword: '正しい確認コードを入力してください',
  codeExpiredForgotPassword:
    '確認コードの有効期限が切れています。再度確認コードを送信してください。',
  emailRequired: 'メールアドレスを入力してください',
  emailFormat: 'メールアドレスの形式が正しくありません',
  passwordRequired: 'パスワードを入力してください',
  passwordFormat:
    '8文字以上の半角英数字記号（大文字、小文字をそれぞれ1文字以上ずつ含める）',
  passwordMismatch: 'パスワードが一致しません',
  newPasswordMismatch: '新しいパスワードが一致しません',
  sameAsCurrentPassword:
    '新しいパスワードは現在のパスワードと異なるパスワードを入力してください',
  invalidEmailOrPassword: 'メールアドレスまたはパスワードが誤っています',
  emailNotExists: '存在しないメールアドレスです',
  invalidCodeOrPassword: '認証コードまたはパスワードが不正です',
  invalidCurrentPassword:
    '現在のパスワードが誤っています。正しいパスワードを入力してください。',
  invalidCodeFormat: '適切な形式の認証コードを入力してください',
  codeExpired: '認証コードの有効期限が切れています',
  codeMismatch: '認証コードが間違っています',
  codeMismatchSetup:
    '二次元コードを読み取り後、表示された認証コードを入力してください',
  codeMismatchDisable: '正しい認証コードを入力してください',
  codeAlreadyUsed: 'この認証コードは既に使用されています',
  accountLocked:
    'アカウントがロックされています。時間を置いて再度お試しください。',
  sessionExpired: `セッションの有効期限が切れております。\n再度ログイン画面よりログインしてください。`,
} as const
